export interface ChatRequestError {
  message: string;
  status?: number;
}

export function isChatForbiddenError(error: ChatRequestError): boolean {
  return Number(error.status) === 403;
}

export function readChatRequestError(payload: unknown, fallback: string): ChatRequestError {
  if (typeof payload === 'string' && payload.length > 0) {
    return { message: payload };
  }

  if (
    payload !== null &&
    typeof payload === 'object' &&
    'message' in payload &&
    typeof (payload as ChatRequestError).message === 'string'
  ) {
    const { message, status } = payload as ChatRequestError;

    return { message, status };
  }

  return { message: fallback };
}
